export class CInput extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });

    const label = this.getAttribute('label') || '';
    const isDisabled = this.hasAttribute('disabled');
    const hasError = this.hasAttribute('error');
    const isReadOnly = this.hasAttribute('readonly');
    const value = this.getAttribute('value') || '';
    const hint = this.getAttribute('hint') || '';
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;
        }

        .input-container{
          display: flex;
          position: relative;
          flex-direction: column;
          row-gap: 5px;
        }
        .wrapper{
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;
          min-width: 200px;
          min-height: 20px;
          cursor: ${isDisabled || isReadOnly ? ' not-allowed' : 'pointer'};
          opacity: ${isDisabled ? '.4' : '1'};
          background-color: ${isReadOnly ? 'transparent' : 'var(--white)'};
          border: 1px ${hasError ? 'var(--error)' : 'var(--black-32)'} solid;
          padding: 12px;
          border-radius: 6px;
          transition: all .3s ease;
          outline: solid;
          outline-width: 2px;
          outline-color: transparent;
        }
        .input-hint{
          display: ${hint ? 'flex' : 'none'};
          font-size: 12px;
          color: ${hasError ? 'var(--error)' : 'var(--black-64)'}
        }
        label {
          position: absolute;
          top: 13px;
          left: 12px;
          color: ${hasError ? 'var(--error)' : 'var(--black)'};
          font-size: 14px;
          transition: all 0.3s ease;
          pointer-events: none;
          opacity: .64
        }

        input {
          position: absolute;
          border: none;
          top: 20px;
          left: 10px;
          outline: none;
          color: white;
          font-size: 16px;
          color: var(--black);
          background-color: transparent;
          pointer-events: none
        }

        input:focus + label,
        input:not(:placeholder-shown) + label {
          top: 3px;
          font-size: 12px;
        }
        .wrapper:focus-within{
          outline-color: ${hasError ? 'var(--error-easy)' : 'var(--tempora-primary-300)'};
          border-color: ${hasError ? 'var(--error)' : 'var(--tempora-primary)'}
        }

        input:focus {
          top: 20px
        }
      </style>

      <div class="input-container">
        <div class="wrapper">
          <input 
            type="text" 
            id="c-input-field" 
            placeholder="" 
            value="${value}"
            ${isDisabled || isReadOnly ? 'disabled="true"' : ''}
          />
          <label 
            for="c-input-field"
          >${label}</label>
        </div>
        <span class="input-hint">${hint}</span>
      </div>
    `;
    this.addEventListener('click', () => {
      const input = this.shadowRoot.querySelector('input');
      input.focus();
    });
  }
}

customElements.define("c-input", CInput);